class OpusRedirect extends HTMLElement {
  connectedCallback () {
    this.init()
  }

  async init () {
    const customerLocation = await this.retrieveCustomerLocation()

    if (customerLocation === 'US') {
      this.activateModal()
    }
  }

  activateModal () {
    this.classList.remove('mod-OpusRedirect_Hidden')
  }

  async retrieveCustomerLocation () {
    return await fetch('https://api.ipgeolocation.io/ipgeo?apiKey=d7c83eb0d2dd40f791ccb65bab1768af')
      .then(response => response.json())
      .then(data => {
        return data.country_code2
      })
  }
}

if (!customElements.get('opus-redirect')) {
  customElements.define('opus-redirect', OpusRedirect)
}
